import PriceInput from './PriceInput';

export * from './PriceInputProps';
export default PriceInput;
